"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _depCheck = _interopRequireDefault(require("../../dep-check"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaSectionHeaderTitle = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([]);
  var children = props.children,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      className = props.className;

  if (children.length > 2) {
    return new Error('Too many children for section header title component. Limit of two.');
  }

  var getClassList = function getClassList() {
    var base = _config.classes.base;
    return (0, _classnames2["default"])(_defineProperty({}, base, true), className);
  };

  var modifyChildClass = function modifyChildClass() {
    var modifiedChildren = _react["default"].Children.map(children, function (child, idx) {
      return _react["default"].cloneElement(child, {
        className: (0, _classnames2["default"])({
          'luna-type-secondary': idx > 0,
          'luna-type-display-inline': true
        }, child.props.className)
      });
    });

    return modifiedChildren;
  };

  return _react["default"].createElement("div", {
    className: getClassList(),
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    ref: ref
  }, modifyChildClass(children));
});

LunaSectionHeaderTitle.propTypes = {
  className: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func
};
LunaSectionHeaderTitle.displayName = 'LunaSectionHeaderTitle';
var _default = LunaSectionHeaderTitle;
exports["default"] = _default;
